/**
 * One quantised input per tick (SPEC §3.5). Every device produces this, so replays are compact and
 * identical on client and server.
 *
 * steer: -127..127 (positive = right), throttle / brake: 0..255, handbrake: 0 or 1.
 */
export interface InputFrame {
  steer: number;
  throttle: number;
  brake: number;
  handbrake: number;
}

export const STEER_MAX = 127;
export const PEDAL_MAX = 255;

export const NEUTRAL_INPUT: Readonly<InputFrame> = {
  steer: 0,
  throttle: 0,
  brake: 0,
  handbrake: 0,
};

/** Quantise analogue values: steer in -1..1, pedals in 0..1. */
export function quantiseInput(
  steer: number,
  throttle: number,
  brake: number,
  handbrake: boolean | number,
  out: InputFrame = { steer: 0, throttle: 0, brake: 0, handbrake: 0 },
): InputFrame {
  out.steer = Math.max(-STEER_MAX, Math.min(STEER_MAX, Math.floor(steer * STEER_MAX + 0.5)));
  out.throttle = Math.max(0, Math.min(PEDAL_MAX, Math.floor(throttle * PEDAL_MAX + 0.5)));
  out.brake = Math.max(0, Math.min(PEDAL_MAX, Math.floor(brake * PEDAL_MAX + 0.5)));
  out.handbrake = handbrake ? 1 : 0;
  return out;
}

export function steerOf(i: InputFrame): number {
  return i.steer / STEER_MAX;
}
export function throttleOf(i: InputFrame): number {
  return i.throttle / PEDAL_MAX;
}
export function brakeOf(i: InputFrame): number {
  return i.brake / PEDAL_MAX;
}
